import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Message } from 'src/app/core/class/message';

@Component({
  selector: 'app-warning-error-file',
  templateUrl: './warning-error-file.component.html',
  styleUrls: ['./warning-error-file.component.scss'],
})
export class WarningErrorFileComponent implements OnInit {
  title = this.message.getMessage('messages.error_list_in_file_title');
  handle = this.message.getMessage('messages.error_list_in_file_handle');

  constructor(
    public message: Message,
    public dialogRef: MatDialogRef<WarningErrorFileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string[]
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  ngOnInit() {}

  onNoClick() {
    this.dialogRef.close();
  }
}
